'use client';

import React from 'react';
import { Discipline } from '@/lib/types';
import { cn } from '@/lib/utils';

interface FilterBarProps {
  disciplines: Discipline[];
  activeFilter: string;
  onFilterChange: (id: string) => void;
}

export default function FilterBar({ disciplines, activeFilter, onFilterChange }: FilterBarProps) {
  return (
    <div className="mb-12 flex flex-wrap gap-2 rounded-xl bg-gray-50 p-4">
      <button
        onClick={() => onFilterChange('all')}
        className={cn(
          'rounded-lg px-6 py-2 text-sm font-bold tracking-wider uppercase transition-all',
          activeFilter === 'all'
            ? 'bg-navy text-white shadow-lg'
            : 'hover:text-navy text-gray-500 hover:bg-white',
        )}
      >
        Tous
      </button>
      {disciplines.map((discipline) => (
        <button
          key={discipline.id}
          onClick={() => onFilterChange(discipline.id)}
          className={cn(
            'rounded-lg px-6 py-2 text-sm font-bold tracking-wider uppercase transition-all',
            activeFilter === discipline.id
              ? 'bg-navy text-white shadow-lg'
              : 'hover:text-navy text-gray-500 hover:bg-white',
          )}
        >
          {discipline.abbr}
        </button>
      ))}
    </div>
  );
}
